import { Typography } from "@circle-react-uikit/Typography";

interface MessagePanelProps {
  children?: React.ReactNode;
  description?: string;
  title?: string;
}

export const MessagePanel = ({
  title,
  description,
  children,
}: MessagePanelProps) => (
  <div
    className="space__gated !bg-primary !border-primary mx-auto"
    data-testid="post_section"
  >
    {title && (
      <Typography.TitleSm weight="semibold">{title}</Typography.TitleSm>
    )}
    {description && (
      <div className="mt-3">
        <Typography.BodyMd>{description}</Typography.BodyMd>
      </div>
    )}
    {children}
  </div>
);
